<template>
    <Submenu :name="menu.menukey">
        <template slot="title">
            <i v-if='menu.icon' :class="menu.icon"></i>
            <span>{{menu.text}}</span>
        </template>
        <template v-for="(item2,index2) in menu.children">
            <template v-if="item2.children&&item2.children.length>0">
                <sideBarItem :menu="item2"></sideBarItem>
            </template>
            <template v-else>
                <MenuItem :name="item2.name">
                <i v-if='item2.icon' :class="item2.icon"></i>
                <span>{{item2.text}}</span>
                </MenuItem>
            </template>
        </template>
    </Submenu>
</template>

<script>
    export default {
        name: "sideBarItem",
        props: {
            menu: Object
        }
    }
</script>